import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import clsx from "clsx";
import useStyles from "../Footer/styles";

import fbIcon from "../../icons/fb.svg";
import instaIcon from "../../icons/insta_footer.svg";
import lnkdinIcon from "../../icons/lnkdin.svg";
import youtubeIcon from "../../icons/youtube.svg";
import SpecificSportsFooter from "./SpecificSportsFooter";

export default function MobileCityFooter() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggleAccordion = () => {
    setIsOpen((prev) => !prev);
  };
  const classes = useStyles();

  const currentPath = location.pathname.toLowerCase();

  const cityMatch = currentPath.match(/in-([a-z-]+)/);
  const cityName = cityMatch
    ? cityMatch[1].replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase())
    : "City";

  const isPune = currentPath.includes("pune");
  const isNagpur = currentPath.includes("nagpur");
  const isHyderabad = currentPath.includes("hyderabad");

  const showCitySpecific = isPune || isNagpur || isHyderabad;

  return (
    <>
      <div>
        <div className={classes.whiteArea}>
          <div>
            <div>
              <h2 className={clsx(classes.textTop)}>
                Top Sports Venues in {cityName}
              </h2>
            </div>
            <section>
              {isHyderabad && (
                <div className={clsx(classes.textBox)}>
                  {/* <h2 className={clsx(classes.textBoxHead)}>Hyderabad</h2> */}
                  <hr className={clsx(classes.cityBorder)}></hr>
                  <p className={clsx(classes.textBoxPara)}>
                    <a
                      href="https://www.khelomore.com/sports-venues/hyderabad/sports/all"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Sports Venues in Hyderabad
                    </a>
                    &nbsp;|&nbsp;
                    <Link to="/pickleball-courts-in-hyderabad">
                      Pickleball Courts in Hyderabad
                    </Link>
                    &nbsp;|&nbsp;
                    <a
                      href="https://www.khelomore.com/sports-venues/hyderabad/sports/badminton"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Badminton Courts in Hyderabad
                    </a>
                    &nbsp;|&nbsp;
                    <a
                      href="https://www.khelomore.com/sports-venues/hyderabad/sports/football"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Football Turfs in Hyderabad
                    </a>
                    &nbsp;|&nbsp;
                    <a
                      href="https://www.khelomore.com/sports-venues/hyderabad/sports/box_cricket"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Box Cricket Turfs in Hyderabad
                    </a>
                    &nbsp;|&nbsp;
                    <a
                      href="https://www.khelomore.com/sports-venues/hyderabad/sports/cricket"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Cricket Grounds in Hyderabad
                    </a>
                    &nbsp;|&nbsp;
                    <a
                      href="https://www.khelomore.com/sports-venues/hyderabad/sports/tennis"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Tennis Courts in Hyderabad
                    </a>
                    &nbsp;|&nbsp;
                    <a
                      href="https://www.khelomore.com/sports-venues/hyderabad/sports/basketball"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Basketball Court in Hyderabad
                    </a>
                    &nbsp;|&nbsp;
                    <a
                      href="https://www.khelomore.com/sports-venues/hyderabad/sports/swimming"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Swimming Pools in Hyderabad
                    </a>
                    &nbsp;|&nbsp;
                    <a
                      href="https://www.khelomore.com/sports-venues/hyderabad/sports/table_tennis"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Table Tennis Clubs in Hyderabad
                    </a>
                  </p>
                </div>
              )}
              {isPune && (
                <div className={clsx(classes.textBox)}>
                  {/* <h2 className={clsx(classes.textBoxHead)}>Pune</h2> */}
                  <hr className={clsx(classes.cityBorder)}></hr>
                  <p className={clsx(classes.textBoxPara)}>
                    <a
                      href="https://www.khelomore.com/sports-venues/pune/sports/all"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Sports Venues in Pune
                    </a>
                    &nbsp;|&nbsp;
                    {/* <Link to="/pickleball-courts-in-pune">
                      Pickleball Courts in Pune
                    </Link> */}
                    {/* &nbsp;|&nbsp; */}
                    <SpecificSportsFooter />
                    {/* <a
                      href="https://www.khelomore.com/sports-venues/pune/sports/badminton"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Badminton Courts in Pune
                    </a>
                    &nbsp;|&nbsp;
                    <a
                      href="https://www.khelomore.com/sports-venues/pune/sports/football"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Football Turfs in Pune
                    </a>
                    &nbsp;|&nbsp;
                    <a
                      href="https://www.khelomore.com/sports-venues/pune/sports/box_cricket"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Box Cricket Turfs in Pune
                    </a>
                    &nbsp;|&nbsp; */}
                    &nbsp;|&nbsp;
                    <a
                      href="https://www.khelomore.com/sports-venues/pune/sports/cricket"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Cricket Grounds in Pune
                    </a>
                    &nbsp;|&nbsp;
                    <a
                      href="https://www.khelomore.com/sports-venues/pune/sports/tennis"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Tennis Courts in Pune
                    </a>
                    &nbsp;|&nbsp;
                    <a
                      href="https://www.khelomore.com/sports-venues/pune/sports/basketball"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Basketball Court in Pune
                    </a>
                    &nbsp;|&nbsp;
                    <a
                      href="https://www.khelomore.com/sports-venues/pune/sports/swimming"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Swimming Pools in Pune
                    </a>
                    &nbsp;|&nbsp;
                    <a
                      href="https://www.khelomore.com/sports-venues/pune/sports/table_tennis"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Table Tennis Clubs in Pune
                    </a>
                  </p>
                </div>
              )}
              {isNagpur && (
                <div className={clsx(classes.textBox)}>
                  {/* <h2 className={clsx(classes.textBoxHead)}>Nagpur</h2> */}
                  <hr className={clsx(classes.cityBorder)}></hr>
                  <p className={clsx(classes.textBoxPara)}>
                    <a
                      href="https://www.khelomore.com/sports-venues/nagpur/sports/all"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Sports Venues in Nagpur
                    </a>
                    &nbsp;|&nbsp;
                    <Link to="/pickleball-courts-in-nagpur">
                      Pickleball Courts in Nagpur
                    </Link>
                    &nbsp;|&nbsp;
                    <a
                      href="https://www.khelomore.com/sports-venues/nagpur/sports/badminton"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Badminton Courts in Nagpur
                    </a>
                    &nbsp;|&nbsp;
                    <a
                      href="https://www.khelomore.com/sports-venues/nagpur/sports/football"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Football Turfs in Nagpur
                    </a>
                    &nbsp;|&nbsp;
                    <a
                      href="https://www.khelomore.com/sports-venues/nagpur/sports/box_cricket"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Box Cricket Turfs in Nagpur
                    </a>
                    &nbsp;|&nbsp;
                    <a
                      href="https://www.khelomore.com/sports-venues/nagpur/sports/cricket"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Cricket Grounds in Nagpur
                    </a>
                  </p>
                </div>
              )}
            </section>
          </div>
        </div>
        <div className={clsx(classes.footerContainer)}>
          <div
            className={clsx(classes.flex, classes.flexWrap, classes.consumers)}
          >
            <div className={clsx(classes.consumersCard)}>
              <h3 className={clsx(classes.consumersHead)}>For Consumers</h3>
              <Link
                to="/privacy-policy"
                className={clsx(classes.consumersText)}
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms-conditions"
                className={clsx(classes.consumersText)}
              >
                Terms & Conditons
              </Link>
              <Link to="/faq" className={clsx(classes.consumersText)}>
                FAQs
              </Link>
              <Link to="/about-us" className={clsx(classes.consumersText)}>
                About Khelomore
              </Link>
              <Link to="/careers" className={clsx(classes.consumersText)}>
                Careers
              </Link>
              <Link
                style={{ marginBottom: "16px" }}
                to="/partnerships"
                className={clsx(classes.consumersText)}
              >
                Partnerships
              </Link>
            </div>
            <div className={clsx(classes.consumersCard)}>
              <h3 className={clsx(classes.consumersHead)}>Categories</h3>
              <a
                href="https://shop.khelomore.com/collections/sport-equipments"
                target="_blank"
                className={clsx(classes.consumersText)}
              >
                Sports Equipment
              </a>
              <a
                href="https://shop.khelomore.com/collections/active-wear-and-shoes"
                target="_blank"
                className={clsx(classes.consumersText)}
              >
                Active Wear & Shoes
              </a>
              <a
                href="https://shop.khelomore.com/collections/acessories-and-essentials"
                target="_blank"
                className={clsx(classes.consumersText)}
              >
                Accessories & Essentials
              </a>
            </div>
          </div>
          <hr className={clsx(classes.hrFooter)}></hr>
          <div className={clsx(classes.socialMediaContainer, classes.mB16)}>
            <div className={clsx(classes.socialMediaCard)}>
              <div>
                <h5
                  style={{ marginBottom: "16px" }}
                  className={clsx(classes.socialMediaHead)}
                >
                  Follow us on
                </h5>
                <div
                  className={clsx(classes.socialMediaIconsCard, classes.flex)}
                >
                  <div
                    className={clsx(
                      classes.socialMediaIcon,
                      classes.flex,
                      classes.justifyCenter
                    )}
                  >
                    <a
                      target="_blank"
                      href="https://www.facebook.com/KheloMore/"
                    >
                      <img src={fbIcon} alt="icon" />
                    </a>
                  </div>
                  <div
                    className={clsx(
                      classes.socialMediaIcon,
                      classes.flex,
                      classes.justifyCenter
                    )}
                  >
                    <a
                      target="_blank"
                      href="https://www.instagram.com/khelomoreindia/"
                    >
                      <img src={instaIcon} alt="icon" />
                    </a>
                  </div>
                  <div
                    className={clsx(
                      classes.socialMediaIcon,
                      classes.flex,
                      classes.justifyCenter
                    )}
                  >
                    <a
                      target="_blank"
                      href="https://www.linkedin.com/company/khelomore/"
                    >
                      <img src={lnkdinIcon} alt="icon" />
                    </a>
                  </div>
                  <div
                    className={clsx(
                      classes.socialMediaIcon,
                      classes.flex,
                      classes.justifyCenter
                    )}
                  >
                    <a target="_blank" href="https://twitter.com/KheloMore">
                      <img
                        className={classes.socialIcon}
                        src="https://km-landing.s3.ap-south-1.amazonaws.com/Images/km-homePageNew/xIcon.png"
                        alt="icon"
                      />
                    </a>
                  </div>
                  <div
                    className={clsx(
                      classes.socialMediaIcon,
                      classes.flex,
                      classes.justifyCenter
                    )}
                  >
                    <a
                      target="_blank"
                      href="https://www.youtube.com/channel/UC9SRqiqrQ1v9RoNX-Lnmqbg"
                    >
                      <img src={youtubeIcon} alt="icon" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr className={clsx(classes.hrFooter)}></hr>
          <div className={clsx(classes.contactSection)}>
            <h6 className={clsx(classes.contactHead)}>Contact Us</h6>
            <div className={clsx(classes.contactText)}>
              <p className={clsx(classes.contactPara)}>
                2nd Floor, KHIL House, Nehru Road, Vile Parle (East),Adjoining
                Orchid Hotel, Mumbai, Maharashtra
              </p>
              <p className={clsx(classes.contactPara)}>
                400099, <span>info@khelomore.com</span>,{" "}
                <span className={classes.contactNumber}>+91 98 1989 0321</span>
              </p>
            </div>
          </div>
        </div>
        <footer
          className={clsx(
            classes.copyright,
            classes.flex,
            classes.justifyCenter,
            classes.alignCenter
          )}
        >
          <small className={clsx(classes.copyrightText)}>
            © 2025 Khelomore Sports Private Limited. All Rights Reserved.
          </small>
        </footer>
      </div>
    </>
  );
}
